export interface PortfolioProject {
  id: string;
  title: string;
  category: string;
  tags: string[];
  emoji: string;
  color: string;
  desc: string;
  year: string;
  hasGithub?: boolean;
  longDesc: string[];
  specs: { label: string; value: string }[];
  challenges: { title: string; desc: string }[];
  coverImage?: string;
  heroImages?: string[];
  gallery: { label: string; image: string; desc: string }[];
  links: { label: string; url?: string }[];
}

const portfolio: PortfolioProject[] = [
   {
    id: 'Low_Poly_Panko',
    title: 'Low Poly Panko',
    category: '3D Models',
    tags: ['Blender', 'VRM', 'Unity'],
    emoji: '🌙',
    color: '#b44fff',
    desc: 'Full-body Low Poly VRM avatar with 60+ expressions, full-body physics, all on a 512x512px canvas!.',
    year: '2026',
    longDesc: [
      "The Low Poly Panko Model - where it all started! I made this model out of my love for the low poly aesthetic! Taking my character design and cyber aesthetic, I was primarily focused on making bringing interesting, emotive facial expressions on a super low polygon budget.",
      "This model is almost entirely made in blender, with textures fixed in aseprite & procreate! The most annoying part was probably fixing with transparency for the mechanical leg - a lot of trial and error were super necessary to get mtoon to behave haha",
      "The hair uses VRM Spring Bones with collisions to prevent clipping during head turns and arm raises",
    ],
    specs: [
      { label: 'VRM File Format', value: 'Perfect For Warudo, Vseeface & vrchat import(VRM)' },
      { label: 'Expressions', value: '12 VRM blendshapes + Full 52 ARKit W/Correctives' },
      { label: 'Toggles', value: '2 (Shirt / Neko Mode)' },
      { label: 'Spring bones', value: 'Springbones for hair & accessories' },
      { label: 'Texture resolution', value: '512x512px - for the low poly compact texture' },
      { label: 'Export formats', value: 'VRM 1.0, .blend' },
    ],
    challenges: [
      { title: 'Metal Leg', desc: 'Super annoying to fix with transparency!' },
      { title: 'Expression range', desc: '60+ expressions including ARKit blendshapes required careful blend shape driver setup and thorough testing across all expression combinations to prevent vertex conflicts.' },
      { title: 'Mtoon shader', desc: 'Achieving a hand-drawn look in VRMrespects the VRM material spec while adding outline width variation based on distance.' },
    ],
    coverImage: '/images/lowpolyrotate.webp',
    heroImages: [
      '/images/lowpolyrotate.webp',
      '/images/lowpolystand.webp',
    ],
    gallery: [
      { label: 'Full body render', image: '/images/lowpolyrotate.webp', desc: 'Fro' },
      { label: 'Physics demo', image: '/images/lowpolystand.webp', desc: 'GIF showing movement and hair physics.' },
      { label: 'Blender View', image: '/images/gallery/blenderviewport1.png', desc: 'The Character From The Blender Viewport' },
      { label: 'Wireframe', image: '/images/wireframeanimation.webp', desc: 'Wireframe overlay showing the retopology flow and edge loops around facial features.' },
      { label: 'VRM vs Arkit', image: '/images/vrmvsarkit.webp', desc: 'VRM (Left) vs Arkit (right) Face Shapes' },
      { label: 'Furry toggle', image: '/images/furriesareok.webp', desc: 'Furry Models are A-Ok!!' },
    ],
    links: [
      { label: 'warudo showcase' },    ],
  },
  /* {
    id: 'High_Poly_Panko',
    title: 'Panko_Model',
    category: '3D Models',
    tags: ['Blender', 'VRM', 'Unity','Photoshop',],
    emoji: '🌙',
    color: '#b44fff',
    desc: 'Full-body VRM avatar with 52 facial expressions, node constraint bones, full-body magicacloth2 physics, poiyomi shader and toggles.',
    year: '2026',
    longDesc: [
      "High Poly, Genshin Style Model built over 2 months! Includes: great face topology, ",
    ],
    specs: [
      { label: 'VRM File Format', value: 'Perfect For Warudo, Vseeface & vrchat import(VRM)' },
      { label: 'Expressions', value: '12 VRM blendshapes + Full ARKit W/Correctives' },
      { label: 'Toggles', value: '2 (day / night)' },
      { label: 'Physics bones', value: 'Magicacloth 2' },
      { label: 'Texture resolution', value: '2048x2048 - for the highpoly textures' },
      { label: 'Export formats', value: '.vrm & .warudo' },
    ],
    challenges: [
      { title: '', desc: ' on a 4-layer board while also fitting PRnector required multiple DRC iterations.' },
      { title: '', desc: 'Chaining 68 SK6812 MINI-E LEDs with the data line while keeping trace length consistent and avoiding antenna effects required careful planning of the routing order around the ortholinear grid.' },
      { title: '', desc: 'The RP2040 requires 17 decoupling capacitors in specific placements near the power rails. Fitting these under the chip in the compact footprint without via stubs required tight via-in-pad placement.' },
    ],
    coverImage: '/images/peace.webp',
    heroImages: [
      '/images/sleepy.webp',
      '/images/lowpolystand.webp',
    ],
    gallery: [
      { label: 'PCB render (top)', image: '/images/gallery/high_poly_panko/01.png', desc: '3D KiCad render of the top side showing component placement and copper fills.' },
      { label: 'PCB render (bottom)', image: '/images/gallery/high_poly_panko/02.png', desc: 'Bottom side render showing USB-C connector placement and SMT component layout.' },
      { label: 'Assembled build', image: '/images/gallery/high_poly_panko/03.png', desc: 'Photo of completed build with Mochi keycap set and Boba U4T switches.' },
      { label: 'Routing screenshot', image: '/images/gallery/high_poly_panko/04.png', desc: 'KiCad routing screenshot highlighting the USB differential pair and RGB chain.' },
    ],
    links: [
      { label: 'GitHub (KiCad files + firmware)', url: '#' },
      { label: 'Build guide' },
      { label: 'JLCPCB order page' },
    ],
  },
  /*{
    id: 'Blender_VRM_Plugin',
    title: 'Blender VRM tools Plugin',
    category: 'VTubing',
    tags: ['OBS', 'Live2D', 'After Effects', 'Illustrator'],
    emoji: '⛩️',
    color: '#ff9fd0',
    desc: 'Complete cyberpunk shrine aesthetic streaming overlay pack with animated alerts, panels, and screen transitions.',
    year: '2026',
    longDesc: [
      "Neon Shrine was born out of a request for something that merged traditional Japanese shrine aesthetics with neon cyberpunk — two things that shouldn't work together but absolutely do. The full kit is 47 files covering every visible element of a modern stream.",
      "All animations were made in After Effects and exported as WebM with alpha channel for OBS browser source compatibility. The colour palette is fully customisable — each After Effects composition has a master colour control so you can shift the entire kit's hue without touching individual layers.",
      "The kit was featured on Booth.pm's front page and has been purchased by over 200 streamers.",
    ],
    specs: [
      { label: 'Resolution', value: '1920×1080 and 2560×1440' },
      { label: 'Total files', value: '47 (WebM, PNG, AEP)' },
      { label: 'Alerts', value: 'Follow, Sub, Donation, Raid, Bits' },
      { label: 'OBS scenes', value: '5 pre-built scene templates' },
      { label: 'Panels', value: '8 Twitch panel designs' },
      { label: 'Font', value: 'Noto Sans JP + custom pixel font' },
    ],
    challenges: [
      { title: 'Alpha-channel WebM compatibility', desc: 'OBS\'s browser source has inconsistent WebM alpha support across GPU vendors. Extensive testing on AMD/Nvidia/Intel was needed to find an encoding preset that worked universally.' },
      { title: 'Colour customisation', desc: 'Building a master-colour system in After Effects that propagates across 47 separate compositions required careful expression scripting rather than manual colour layers.' },
      { title: 'File size', desc: 'Animated alerts needed to be under 2MB per file for Twitch upload limits while maintaining quality at 1440p — required aggressive bitrate tuning and dropping to 30fps for looping elements.' },
    ],
    coverImage: '/images/peace.webp',
    heroImages: [
      '/images/sleepy.webp',
      '/images/lowpolystand.webp',
    ],
    gallery: [
      { label: 'Full stream preview', image: '/images/gallery/blender_vrm_plugin/01.png', desc: 'Mock stream screenshot showing all overlay elements active simultaneously.' },
      { label: 'Alert animations', image: '/images/gallery/blender_vrm_plugin/02.png', desc: 'Side-by-side preview of all 5 alert types.' },
      { label: 'Panel designs', image: '/images/gallery/blender_vrm_plugin/03.png', desc: 'All 8 panel designs laid out on a dark background.' },
      { label: 'Scene templates', image: '/images/gallery/blender_vrm_plugin/04.png', desc: 'OBS scene collection screenshot showing all 5 template scenes.' },
    ],
    links: [
      { label: 'Booth.pm listing' },
      { label: 'Preview video' },
    ],
  },
 /* {
    id: 'Live2d_Panko',
    title: 'Live2d Panko',
    category: 'Hacking',
    tags: ['C', 'Flipper Zero', 'NFC', 'Embedded'],
    emoji: '📡',
    color: '#c97cff',
    desc: 'Custom Flipper Zero firmware module for advanced NFC card analysis. Presented at local DEF CON group.',
    year: '2025',
    hasGithub: true,
    longDesc: [
      "The stock Flipper Zero NFC app handles basic card reading and emulation well, but falls short for deeper analysis work — specifically around nested authentication on MIFARE Classic cards and extended NDEF record parsing. This module fills those gaps.",
      "Written in C against the Flipper Zero firmware SDK, the toolkit adds: automated MIFARE Classic nested attack dictionary, extended NDEF parser with hex inspector, and a simple scripting interface for running multi-step NFC workflows from a text file on the SD card.",
      "The project was presented at the local DEF CON group meetup as a walkthrough of Flipper Zero firmware development and NFC protocol internals. Slides and the writeup are available in the repo.",
    ],
    specs: [
      { label: 'Language', value: 'C (Flipper Zero SDK)' },
      { label: 'Target', value: 'Flipper Zero (STM32WB55)' },
      { label: 'Supported cards', value: 'MIFARE Classic 1K/4K, NDEF Type 2/4' },
      { label: 'Attack modes', value: 'Nested auth, darkside, dictionary' },
      { label: 'Lines of code', value: '~2,800' },
      { label: 'License', value: 'MIT' },
    ],
    challenges: [
      { title: 'Nested authentication attack', desc: 'Implementing the MIFARE Classic nested authentication attack within Flipper\'s constrained memory (256KB RAM) required a streaming dictionary approach rather than loading the full wordlist.' },
      { title: 'Firmware SDK limitations', desc: 'The Flipper SDK lacks a heap allocator for large buffers. Working around this for NDEF record parsing required a custom arena allocator on the stack with careful bounds checking.' },
      { title: 'Timing sensitivity', desc: 'NFC nested attacks are extremely timing-sensitive. Calibrating the timing constants for the ST25R3916 RF frontend required an oscilloscope and iterative measurement.' },
    ],
    coverImage: '/images/bodyxlive2d.webp',
    heroImages: [
      '/images/sleepy.webp',
      '/images/lowpolystand.webp',
    ],
    gallery: [
      { label: 'Flipper UI screenshot', image: '/images/gallery/live2d_panko/01.png', desc: 'Photo of the Flipper Zero screen showing the toolkit menu.' },
      { label: 'NDEF parser output', image: '/images/gallery/live2d_panko/02.png', desc: 'Screenshot of extended NDEF record output on a complex Type 4 tag.' },
      { label: 'DEF CON slides', image: '/images/gallery/live2d_panko/03.png', desc: 'Title slide from the local DEF CON group presentation.' },
      { label: 'Oscilloscope trace', image: '/images/gallery/live2d_panko/04.png', desc: 'Oscilloscope capture showing NFC timing calibration for nested attack.' },
    ],
    links: [
      { label: 'GitHub repository', url: '#' },
      { label: 'DEF CON group writeup' },
      { label: 'Presentation slides (PDF)' },
    ],
  },
  */
  {
    id: 'panko-stickers',
    title: 'Panko Stickers',
    category: 'Merch',
    tags: ['Stickers', 'Merch', 'Illustration', 'Procreate'],
    emoji: '🐉',
    color: '#ff6eb4',
    desc: 'Original die-cut sticker designs featuring panko\'s character and hacker aesthetic. Available on Patreon.',
    year: '2025',
    longDesc: [
      "A set of original die-cut stickers designed around panko's character and the hacker/cyber aesthetic that runs through everything I make. Each design went through multiple sketch rounds before being finalised in Procreate and prepared for print.",
      "The designs range from character chibi poses to icon-style hacker motifs. Print files are set up at 300dpi with bleed and cut lines for professional sticker printing. Available to Patreon supporters.",
    ],
    specs: [
      { label: 'Format', value: 'Die-cut stickers' },
      { label: 'Resolution', value: '300 dpi, print-ready' },
      { label: 'Tools', value: 'Procreate, Photoshop' },
      { label: 'Available via', value: 'Patreon shop' },
    ],
    challenges: [
      { title: 'Designing for die-cut', desc: 'Die-cut stickers need clean, printable silhouettes with enough bleed — detailed linework or thin elements that look great on screen can fall apart at sticker size or get eaten by the cut.' },
      { title: 'Keeping the aesthetic consistent', desc: 'Stickers need to feel like a set. Every design shares the same colour palette, line weight, and energy so they look good grouped together.' },
    ],
    coverImage: '/images/stickerstogether2.webp',
    heroImages: [
      '/images/stickerstogether2.webp',
      '/images/stickerstogether2.webp',
    ],
    gallery: [
      { label: 'Sticker sheet', image: '/images/gallery/stickers_panko/01.png', desc: 'Full sheet showing all sticker designs together.' },
      { label: 'Character designs', image: '/images/gallery/stickers_panko/02.png', desc: 'Close-up of the character chibi sticker designs.' },
      { label: 'Hacker motifs', image: '/images/gallery/stickers_panko/03.png', desc: 'Icon-style hacker/cyber motif stickers.' },
      { label: 'Printed samples', image: '/images/gallery/stickers_panko/04.png', desc: 'Photo of printed stickers.' },
    ],
    links: [
      { label: 'Patreon shop', url: 'https://www.patreon.com/c/panekopanko' },
    ],
  },
  {
    id: 'panko-lanyard',
    title: 'Panko Lanyard',
    category: 'Merch',
    tags: ['Merch', 'Lanyard', 'Design', 'Hardware'],
    emoji: '🪪',
    color: '#ff6eb4',
    desc: 'Custom-printed lanyard featuring panko\'s character design and branding. Available on Patreon.',
    year: '2025',
    longDesc: [
      "A custom lanyard designed as wearable merch for cons and everyday carry. The design wraps panko's character and cyber branding across the full lanyard length.",
      "The design was laid out to tile cleanly across the print surface — lanyard printing is a weird format where your artwork repeats every ~50cm, so the pattern has to read well both as individual repeats and as a continuous strip.",
    ],
    specs: [
      { label: 'Format', value: 'Full-colour sublimation print lanyard' },
      { label: 'Width', value: '20mm' },
      { label: 'Tools', value: 'Illustrator, Photoshop' },
      { label: 'Available via', value: 'Patreon shop' },
    ],
    challenges: [
      { title: 'Tiling layout', desc: 'Lanyard artwork repeats every ~50cm on the print strip. The design has to look intentional at every repeat, not like a copy-paste job — which means the motifs need to flow into each other naturally.' },
    ],
    coverImage: '/images/gallery/panko_lanyard.jpg',
    heroImages: [
      '/images/sleepy.webp',
      '/images/lowpolystand.webp',
    ],
    gallery: [
      { label: 'Full design', image: '/images/gallery/lanyard/01.png', desc: 'Flat lay of the full lanyard design.' },
      { label: 'Detail shot', image: '/images/gallery/lanyard/02.png', desc: 'Close-up of the character and branding elements.' },
      { label: 'Worn', image: '/images/gallery/lanyard/03.png', desc: 'Photo of the lanyard being worn at a con.' },
    ],
    links: [
      { label: 'Patreon shop', url: 'https://www.patreon.com/c/panekopanko' },
    ],
  },
  {
    id: 'pwnagotchi',
    title: 'Pwnagotchi',
    category: 'Hacking',
    tags: ['Pwnagotchi', 'Raspberry Pi', 'Python', 'WiFi', 'Hardware'],
    emoji: '👾',
    color: '#c97cff',
    desc: 'Custom Pwnagotchi build — a Raspberry Pi Zero 2W that learns to harvest WPA handshakes and displays mood on an e-ink screen.',
    year: '2025',
    hasGithub: true,
    longDesc: [
      "A Pwnagotchi is a Raspberry Pi-based AI that uses bettercap to passively capture WPA/WPA2 handshakes from nearby WiFi networks. It uses a reinforcement learning model (A2C) to tune its own capture parameters over time — the more it runs, the better it gets at finding networks to interact with.",
      "My build runs on a Raspberry Pi Zero 2W with a Waveshare 2.13\" e-ink display, custom 3D-printed case, and a small LiPo battery for portable operation. The face on the display changes mood based on activity — happy when capturing handshakes, sad when nothing is around, bored when sleeping.",
      "I added a custom panko-themed UI skin, tweaked the personality config, and wrote a small plugin that logs capture stats to a local CSV for later analysis. The captured handshakes get run through hashcat on a separate machine.",
    ],
    specs: [
      { label: 'Hardware', value: 'Raspberry Pi Zero 2W' },
      { label: 'Display', value: 'Waveshare 2.13" e-ink' },
      { label: 'OS', value: 'Pwnagotchi (Raspbian-based)' },
      { label: 'Attack mode', value: 'Passive WPA/WPA2 PMKID + handshake capture' },
      { label: 'AI model', value: 'A2C (Advantage Actor-Critic)' },
      { label: 'Battery', value: 'LiPo, ~8h runtime' },
      { label: 'Case', value: '3D printed, custom' },
    ],
    challenges: [
      { title: 'Power budget on Zero 2W', desc: 'The Pi Zero 2W draws more than the original Zero W, which affects battery life significantly. Tuning sleep intervals and disabling unused interfaces kept it under 200mA average.' },
      { title: 'Custom skin', desc: 'Pwnagotchi\'s display UI is defined in a Python plugin. Replicating the panko character aesthetic in a 250×122 pixel e-ink canvas with no greyscale required careful 1-bit dithering on the face sprites.' },
      { title: 'Capture rate vs. detectability', desc: 'More aggressive channel hopping captures more handshakes but increases the chance of appearing in nearby network logs. Tuning the AI personality parameters for a balance took field testing.' },
    ],
    coverImage: '/images/pankogotchi.jpg',
    heroImages: [
      '/images/.w',
      '/images/lowpolystand.webp',
    ],
    gallery: [
      { label: 'The build', image: '/images/gallery/pwnagotchi/01.png', desc: 'Photo of the completed Pwnagotchi with e-ink face active.' },
      { label: 'Custom skin', image: '/images/gallery/pwnagotchi/02.png', desc: 'Close-up of the panko-themed e-ink display skin.' },
      { label: 'Inside the case', image: '/images/gallery/pwnagotchi/03.png', desc: 'Open case showing the Pi Zero 2W, LiPo, and display wiring.' },
      { label: 'Capture stats', image: '/images/gallery/pwnagotchi/04.png', desc: 'Screenshot of the CSV capture log and hashcat run.' },
    ],
    links: [
      { label: 'GitHub (plugins + skin)', url: '#' },
      { label: 'Patreon (build guide)', url: 'https://www.patreon.com/c/panekopanko' },
    ],
  },
  /*{
    id: 'Ayricu Low Poly Model',
    title: 'Ayricu ',
    category: 'PCB',
    tags: ['KiCad', 'ATtiny', 'SAO', 'RF', 'RGB'],
    emoji: '💊',
    color: '#b44fff',
    desc: 'SAO-compatible conference badge PCB with RGB matrix display and wireless mesh networking via nRF24L01.',
    year: '2026',
    hasGithub: true,
    longDesc: [
      "PinkPill is an SAO (Shitty Add-On) badge designed for hacker conferences. The pill-shaped form factor houses an 8×8 RGB LED matrix driven by an ATtiny3217, a nRF24L01+ module for wireless mesh comms between nearby badges, and the standard SAO 1.69 connector.",
      "The wireless mesh lets nearby badge holders send short text messages to each other — a simple but delightful interaction at crowded conferences. The firmware implements a basic CSMA/CA protocol on top of the nRF24L01's Enhanced ShockBurst to handle collisions when many badges are in range.",
      "30 units were hand-assembled and distributed at the conference. The design is fully open-source with a detailed assembly guide targeting builders with basic SMD soldering skills.",
    ],
    specs: [
      { label: 'MCU', value: 'ATtiny3217 (8-bit AVR, 32KB flash)' },
      { label: 'Display', value: '8×8 WS2812B RGB matrix' },
      { label: 'RF', value: 'nRF24L01+ (2.4 GHz, 250kbps–2Mbps)' },
      { label: 'Connector', value: 'SAO 1.69 (I²C + GPIO)' },
      { label: 'Power', value: '3.3V LDO from SAO 3.3V rail' },
      { label: 'Dimensions', value: '45mm × 22mm (pill shape)' },
      { label: 'Units made', value: '30 (hand-assembled)' },
    ],
    challenges: [
      { title: 'Power budget on SAO 3.3V', desc: 'The SAO spec only guarantees 100mA on the 3.3V rail. The 8×8 WS2812B matrix can draw up to 1.9A at full white. A firmware brightness cap and per-channel power averaging keep peak draw under 90mA.' },
      { title: 'Pill form factor routing', desc: 'Routing the nRF24L01 RF section with a proper 50Ω trace to the PCB antenna in an irregular pill-shaped PCB outline required careful placement relative to the keep-out zone.' },
      { title: 'Mesh CSMA/CA on nRF24L01', desc: 'The nRF24L01 has no built-in collision avoidance. Implementing basic CSMA/CA in firmware on an 8-bit MCU with 32KB flash required a very lightweight protocol stack.' },
    ],
    coverImage: '/images/peace.webp',
    heroImages: [
      '/images/sleepy.webp',
      '/images/lowpolystand.webp',
    ],
    gallery: [
      { label: 'Badge front', image: '/images/gallery/ayricu_low_poly/01.png', desc: 'Photo of assembled badge front with RGB matrix running a wave animation.' },
      { label: 'Badge back', image: '/images/gallery/ayricu_low_poly/02.png', desc: 'Back side showing SAO connector and nRF24L01 module.' },
      { label: 'PCB layout', image: '/images/gallery/ayricu_low_poly/03.png', desc: 'KiCad PCB view showing the pill-shaped outline and component placement.' },
      { label: 'Mesh demo', image: '/images/gallery/ayricu_low_poly/04.png', desc: 'Photo of multiple badges communicating at the conference.' },
    ],
    links: [
      { label: 'GitHub (KiCad + firmware)', url: '#' },
      { label: 'Assembly guide' },
    ],
  }, */
  /*{
    id: 'ctf-writeup-collection',
    title: 'CTF Writeup Collection',
    category: 'Hacking',
    tags: ['Reverse Engineering', 'Pwn', 'Crypto', 'Hardware', 'Ghidra', 'pwntools'],
    emoji: '🏴',
    color: '#ff9fd0',
    desc: 'Collection of 40+ detailed CTF writeups covering reverse engineering, binary exploitation, and hardware challenges.',
    year: '2024-NOW',
    hasGithub: true,
    longDesc: [
      "This repository documents solutions to 40+ CTF challenges across events including picoCTF, HTB CTF, and several European university CTFs. The writeups prioritise teaching the methodology rather than just the solution — each one explains the wrong turns before the right answer.",
      "Categories covered include: reverse engineering (x86-64, ARM, WASM), binary exploitation (stack/heap, ret2libc, format strings), hardware (UART/JTAG extraction, signal analysis), and a selection of cryptography challenges.",
      "The repo is structured so you can filter by CTF event, category, or difficulty. It's also used as curriculum material in my coaching sessions.",
    ],
    specs: [
      { label: 'Total writeups', value: '43' },
      { label: 'CTF events covered', value: '11' },
      { label: 'Categories', value: 'RE, Pwn, Crypto, Hardware, Misc' },
      { label: 'Tools referenced', value: 'Ghidra, pwntools, angr, sigrok, GDB' },
      { label: 'Languages', value: 'Python, C, Assembly (x86-64, ARM)' },
      { label: 'Difficulty range', value: 'Easy → Expert' },
    ],
    challenges: [
      { title: 'Hardware challenge documentation', desc: 'Hardware CTF writeups require photos and logic analyser captures. Building a reproducible documentation workflow with consistent image quality took iteration across several events.' },
      { title: 'Keeping writeups current', desc: 'Challenge environments go offline. Where possible, writeups include local reproduction steps using Docker or provided binaries so they remain useful after event closure.' },
      { title: 'Teaching vs. spoiling', desc: 'Walking the line between a useful teaching writeup and just giving the flag required structuring each writeup as a narrative of discovery rather than a linear solution.' },
    ],
    coverImage: '/images/peace.webp',
    heroImages: [
      '/images/sleepy.webp',
      '/images/lowpolystand.webp',
    ],
    gallery: [
      { label: 'Repo structure', image: '/images/gallery/ctf_writeups/01.png', desc: 'Screenshot of the organised repo directory by category and event.' },
      { label: 'RE writeup sample', image: '/images/gallery/ctf_writeups/02.png', desc: 'Page from a reverse engineering writeup showing Ghidra decompilation and annotation.' },
      { label: 'Hardware writeup', image: '/images/gallery/ctf_writeups/03.png', desc: 'Page showing UART extraction with a logic analyser capture and decoded output.' },
      { label: 'Stats dashboard', image: '/images/gallery/ctf_writeups/04.png', desc: 'Auto-generated stats page showing breakdown by category and difficulty.' },
    ],
    links: [
      { label: 'GitHub repository', url: '#' },
      { label: 'CTFtime profile' },
    ],
  },
  */{
    id: 'vtubermodel-wiki',
    title: 'vtubermodel.wiki',
    category: 'Web',
    tags: ['Vite', 'React', 'Markdown', 'Docs', 'VTubing'],
    emoji: '📖',
    color: '#ff9fd0',
    desc: 'A free, open wiki covering everything about VTuber models — from concept and commissioning through Live2D rigging, 3D modelling, tracking, and streaming. 96 pages.',
    year: '2025',
    hasGithub: true,
    longDesc: [
      "vtubermodel.wiki started because I kept answering the same questions over and over — in DMs, in Discord servers, in comments. Instead of copy-pasting the same answers forever, I wrote them down properly and put them somewhere anyone could find.",
      "The wiki covers the entire VTuber model pipeline: how to develop a character concept, how to commission art and rigging safely (including how not to get scammed), Live2D rigging fundamentals like PerfectSync and ARKit blendshapes, 3D modelling in Blender with VRM export, physics via Spring Bones and MagicaCloth2, face tracking setup and tuning, Warudo configuration, and streaming software. 96 pages across 10+ topic sections.",
      "Built with Vite and React, all content is written in Markdown and loaded dynamically — no CMS, no database. The site has full-text search, table of contents generation per page, breadcrumb navigation, and a prev/next page system. The design is clean and readable, tuned for reference use rather than casual browsing.",
    ],
    specs: [
      { label: 'Pages', value: '96 Markdown files' },
      { label: 'Topic sections', value: 'Live2D, 3D Modelling, Tracking, Warudo, Buying, Streaming, Body Tracking, Hacking, Resources' },
      { label: 'Stack', value: 'Vite + React + Markdown (via import.meta.glob)' },
      { label: 'Features', value: 'Full-text search, ToC, breadcrumbs, prev/next navigation' },
      { label: 'Hosting', value: 'vtubermodel.wiki' },
      { label: 'License', value: 'Open — contributions welcome on GitHub' },
    ],
    challenges: [
      { title: 'Scope creep (the good kind)', desc: 'The wiki started as a handful of Live2D rigging notes. Every time someone asked a question I didn\'t have a page for, I wrote one. 96 pages later, it covers the full VTuber pipeline from concept art through streaming software.' },
      { title: 'Making technical content approachable', desc: 'Topics like VRM bone constraints, ARKit blendshape correctives, and CSMA/CA face tracking protocols are genuinely complex. Writing guides that are accurate enough for advanced users but readable for beginners required multiple rewrites per page.' },
      { title: 'No CMS, no database', desc: 'All content is raw Markdown, loaded with import.meta.glob. Building search, table of contents, breadcrumbs, and navigation entirely from the Markdown file tree without a backend required careful path resolution and client-side indexing.' },
    ],
    coverImage: '/images/peace.webp',
    heroImages: [
      '/images/sleepy.webp',
      '/images/lowpolystand.webp',
    ],
    gallery: [
      { label: 'Home page', image: '/images/gallery/vtubermodel_wiki/01.png', desc: 'The wiki home page with topic navigation and start-here paths.' },
      { label: 'Live2D guide', image: '/images/gallery/vtubermodel_wiki/02.png', desc: 'A Live2D rigging guide showing parameter tables and diagrams.' },
      { label: '3D / VRM guide', image: '/images/gallery/vtubermodel_wiki/03.png', desc: 'VRM file format reference with bone hierarchy and expression system docs.' },
      { label: 'Buying guide', image: '/images/gallery/vtubermodel_wiki/04.png', desc: 'The commissioning checklist and scam-avoidance guide.' },
    ],
    links: [
      { label: 'Visit vtubermodel.wiki', url: 'https://vtubermodel.wiki' },
      { label: 'GitHub', url: '#' },
    ],
  },
];

export default portfolio;
